import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable max-len */
export const IconDownload = props => /*#__PURE__*/_jsx("svg", {
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    d: "M7.536 2v8.105L3.784 6.353l-.707.707 4.95 4.951.707-.707 4.242-4.244-.706-.707-3.734 3.734V2h-1ZM2 14h12v-1H2v1Z"
  })
});
//# sourceMappingURL=es/Icon/Download.js.map